import { ExpensesValueObjectsPaymentOptionsEnum } from 'generated/resources/graphql'

import { type ExpenseFormValues } from 'modules/expenses/components/expenses/Detail/_Form/Expense/new/form/form'
import { type MileageFormValues } from 'modules/expenses/components/expenses/Detail/_Form/Mileage/new/form/form'
import { type PerDiemFormValues } from 'modules/expenses/components/expenses/Detail/_Form/PerDiem/new/form/form'

// Type guards for form values
export const isExpenseFormValues = (
  values: ExpenseFormValues | PerDiemFormValues | MileageFormValues,
  formType: string
): values is ExpenseFormValues => {
  return formType === 'expense' && 'taxes' in values
}

export const isPerDiemFormValues = (
  values: ExpenseFormValues | PerDiemFormValues | MileageFormValues,
  formType: string
): values is PerDiemFormValues => {
  return formType === 'perdiem' && 'rates' in values
}

export const isMileageFormValues = (
  values: ExpenseFormValues | PerDiemFormValues | MileageFormValues,
  formType: string
): values is MileageFormValues => {
  return formType === 'mileage' && 'units' in values
}

export const validatePaymentOption = (payment: string): ExpensesValueObjectsPaymentOptionsEnum => {
  if (payment === 'reimbursable' || payment === 'Reimbursable') {
    return 'reimbursable'
  } else if (payment === 'not_reimbursable' || payment === 'NotReimbursable') {
    return 'not_reimbursable'
  }
  // Default fallback
  return 'reimbursable'
}
